import { inject, Injectable, Signal, signal } from '@angular/core';
import { ReadonlyRepositoryCollectionService } from '@softline/core';
import { AbcAnalysisBaseMeasuresRepository } from '../repositories/abc-analysis-base-measures.repository';
import { AbcAnalysisBaseMeasureDto } from '../types/abc-analysis-base-measure';

@Injectable()
export class AbcAnalysisBaseMeasuresService extends ReadonlyRepositoryCollectionService<
  AbcAnalysisBaseMeasureDto,
  AbcAnalysisBaseMeasureDto[],
  undefined
> {
  override readonly params: Signal<undefined> = signal(undefined);

  constructor() {
    super(inject(AbcAnalysisBaseMeasuresRepository));
  }

  protected override getAll(
    result: AbcAnalysisBaseMeasureDto[] | null | undefined
  ): AbcAnalysisBaseMeasureDto[] {
    return result ?? [];
  }

  protected override getId = (item: AbcAnalysisBaseMeasureDto): string => item.baseMeasure;
}
